import {Alert, Button, Grid } from "@mui/material";
import { Card, CardMedia, CardActions } from "@mui/material";

const ErrorMessage = ({ message }) => {
  if (!message) return null;

  return (
    <div>
      <Grid container justifyContent="center">
                        <Card
                          sx={{ width: 700, alignSelf: "center", alignItems: "center" }}
                          variant="outlined"
                        >
                          <CardMedia>
                            <Alert
                              severity={
                               "error"
                              }
                              sx={{
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              { true &&
                                message}
                            </Alert>
                          </CardMedia>
                        </Card>
      </Grid>
    </div>
  );
};


export default ErrorMessage;
